import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";

const SiteContentContext = createContext({
    content: null,
    loading: true,
    refresh: () => {},
});

export const SiteContentProvider = ({ children }) => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        try {
            const { data } = await axios.get(`${API}/content/site`);
            setContent(data);
        } catch (e) {
            // Fail silently — components have hardcoded fallbacks
            console.warn("Site content load failed", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refresh();
    }, []);

    return (
        <SiteContentContext.Provider value={{ content, loading, refresh }}>
            {children}
        </SiteContentContext.Provider>
    );
};

export const useSiteContent = () => useContext(SiteContentContext);

// Helpers to safely read with fallback
export const getSection = (content, section, fallback = {}) => {
    if (!content) return fallback;
    return content[section] || fallback;
};
